import FanDemoGraphics from "components/FanDemoGraphics";
import Header from "components/Headers/Header";
import TabsInfoModal from "components/Modal/TabsInfoModal";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Spinner } from "reactstrap";
import { getFanSurvey } from "store/actions/fanDataAction";

const FanSurvey = () => {
  let dispatch = useDispatch();
  const [Loader, setLoader] = useState({
    data: false,
    btn: false,
  });
  let { fanSurvey } = useSelector((state) => state.fans);
  const infoPoints = [
    "Admin overview the Fan survey of fan registration at FHP",
  ];
  const subPoints = [];
  const infoTitle = "Fans Survey Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  useEffect(() => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getFanSurvey(() => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  }, []);
  return (
    <>
      <Header />
      <Container fluid className="mb-5">
        <Row>
          <h2
            className="mb-0 ml-auto m-2 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>{" "}
        </Row>
        <div className="">
          <h1 className="text-center my-4 text-title">
            SURVEY QUESTIONS OF FANS REGISTERED AT FHP
          </h1>
          {Loader.data ? (
            <div className="text-center">
              <Spinner color="primary" />
            </div>
          ) : (
            <div className="d-flex flex-column flex-row justify-content-center align-items-center">
              <FanDemoGraphics
                series={[
                  fanSurvey?.notforHighSchool ? fanSurvey?.notforHighSchool : 0,
                  fanSurvey?.someCollege ? fanSurvey?.someCollege : 0,
                  fanSurvey?.someHighSchool ? fanSurvey?.someHighSchool : 0,
                ]}
                labels={[
                  "Not For College And High School",
                  "Some College Butt Not For High School",
                  "Both College and At least Some High Schools",
                ]}
                type="Fans Survey"
                size={10}
              />
            </div>
          )}
        </div>
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={infoPoints}
        title={infoTitle}
        subPoints={subPoints}
      />
    </>
  );
};
export default FanSurvey;
